/** Labeled wrapper for one control in a filter panel grid. */
export function FilterField({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-xs font-semibold text-foreground">{label}</span>
      {children}
    </label>
  );
}
